import React, { useContext, useMemo } from 'react';

// CONTEXT
import { ListContext } from 'helpers/getListData';

// GLOBAL COMPONENTS
import Filters from 'parts/filters/Filters';

// MAIN COMPONENT
const SortFilter = ({
  options,
  ...props
}) => {

  // CONTEXT
  const {
    preferences: {
      showColumns = []
    },
    columns = []
  } = useContext(ListContext) || {};

  // MEMOS
  const optionsMemo = useMemo(
    () => options || columns.map(({
      key,
      sortable = true,
      sortKey = sortable ? key : undefined,
      label
    }) =>!sortable || !showColumns.includes(key) ? undefined : {
      label,
      value: sortKey
    }).filter(Boolean),
    [options, columns, showColumns]
  )

  // RETURN
  return (
    <Filters.Sort
      options={optionsMemo}
      {...props}
    />
  )
}

// EXPORT
export default SortFilter;
